export default "__VITE_ASSET__C_FrPd1Y__"